import Vue from "vue";
import Router from "vue-router";
import store from "../store/";

Vue.use(Router);

import routes from "./routes";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  await Vue.nextTick();
  if (to.meta.requiresAuth) {
    if (store.state.user) {
      if (
        (!store.state.currentHotel && to.meta.requiresHotel) ||
        (["accounts", "emailtemplates"].includes(to.name) &&
          store.state.user.accessType === 11)
      ) {
        next("dashboard");
      } else {
        next();
      }
    } else {
      next("login");
    }
  } else if (store.state.user && to.name === "login") {
    next("dashboard");
  } else {
    next();
  }
});

export default router;
